export const APP_URL = window.location.origin;
export const APP_ICON = `${APP_URL}/brand/assets/app-icons/icon-128x128.png`;
export const LOGIN_URL = `${APP_URL}/login`;
export const API_URL_DEFAULT = process.env.API_URL_DEFAULT;
export const GOOGLE_TAG_MANAGER_ID = 'GTM-MG5LFTG';
export const IS_NOT_DEV = process.env.BRANCH !== 'develop';
export const IS_MASTER = process.env.BRANCH === 'main';
export const IS_PROD = process.env.NODE_ENV === 'production';
export const CIAM_LOGOUT = process.env.CIAM_LOGOUT;
